export const DEFAULT_DELAY_SHOW_ALERT_IN_MILLISECONDS = 3000;

export const SUCESSFUL_GENERATED_PROJECT_REPORT = {
  message: "one_pager_report.successful_download_message",
  severity: "success"
}

export const SUCESSFUL_GENERATED_PORTFOLIO_REPORT = {
  message: "one_pager_report.successful_portfolio_download_message",
  severity: "success"
}

export const SUCESSFUL_GENERATED_AGREEMENT_REPORT = {
  message: "one_pager_report.successful_agreement_download_message",
  severity: "success"
}

export const ERROR_IN_GENERATE_REPORT = {
  message: "one_pager_report.error_download_message",
  severity: "error"
}

